import { getReviews, deleteReview } from '../services/napi';
import { REVIEWS_FETCH_SUCCESS } from '../constant/actionType';

export function fetchReviews() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getReviews(projectId);
    dispatch({ data: response.data.reviews, type: REVIEWS_FETCH_SUCCESS });
  };
}

export function removeReview(projectId, orderId, onSuccess) {
  return async () => {
    await deleteReview(projectId, orderId);
    onSuccess();
  };
}
